// extracted by mini-css-extract-plugin
export default {"Separator":"Separator_442T6","horizontal":"horizontal_hBl58","vertical":"vertical_+ftYt"};